﻿var language = $('meta[name="accept-language"]').attr("content");

switch (language) {
    case "en-GB":
        Date.CultureInfo = { name: "en-US", englishName: "English (United States)", nativeName: "English (United States)", dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], abbreviatedDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], shortestDayNames: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], firstLetterDayNames: ["S", "M", "T", "W", "T", "F", "S"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], abbreviatedMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], amDesignator: "AM", pmDesignator: "PM", firstDayOfWeek: 0, twoDigitYearMax: 2029, dateElementOrder: "mdy", formatPatterns: { shortDate: "M/d/yyyy", longDate: "dddd, MMMM dd, yyyy", shortTime: "h:mm tt", longTime: "h:mm:ss tt", fullDateTime: "dddd, MMMM dd, yyyy h:mm:ss tt", sortableDateTime: "yyyy-MM-ddTHH:mm:ss", universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ", rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT", monthDay: "MMMM dd", yearMonth: "MMMM, yyyy" }, regexPatterns: { jan: /^jan(uary)?/i, feb: /^feb(ruary)?/i, mar: /^mar(ch)?/i, apr: /^apr(il)?/i, may: /^may/i, jun: /^jun(e)?/i, jul: /^jul(y)?/i, aug: /^aug(ust)?/i, sep: /^sep(t(ember)?)?/i, oct: /^oct(ober)?/i, nov: /^nov(ember)?/i, dec: /^dec(ember)?/i, sun: /^su(n(day)?)?/i, mon: /^mo(n(day)?)?/i, tue: /^tu(e(s(day)?)?)?/i, wed: /^we(d(nesday)?)?/i, thu: /^th(u(r(s(day)?)?)?)?/i, fri: /^fr(i(day)?)?/i, sat: /^sa(t(urday)?)?/i, future: /^next/i, past: /^last|past|prev(ious)?/i, add: /^(\+|aft(er)?|from|hence)/i, subtract: /^(\-|bef(ore)?|ago)/i, yesterday: /^yes(terday)?/i, today: /^t(od(ay)?)?/i, tomorrow: /^tom(orrow)?/i, now: /^n(ow)?/i, millisecond: /^ms|milli(second)?s?/i, second: /^sec(ond)?s?/i, minute: /^mn|min(ute)?s?/i, hour: /^h(our)?s?/i, week: /^w(eek)?s?/i, month: /^m(onth)?s?/i, day: /^d(ay)?s?/i, year: /^y(ear)?s?/i, shortMeridian: /^(a|p)/i, longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i, timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i, ordinalSuffix: /^\s*(st|nd|rd|th)/i, timeContext: /^\s*(\:|a(?!u|p)|p)/i }, timezones: [{ name: "UTC", offset: "-000" }, { name: "GMT", offset: "-000" }, { name: "EST", offset: "-0500" }, { name: "EDT", offset: "-0400" }, { name: "CST", offset: "-0600" }, { name: "CDT", offset: "-0500" }, { name: "MST", offset: "-0700" }, { name: "MDT", offset: "-0600" }, { name: "PST", offset: "-0800" }, { name: "PDT", offset: "-0700" }] };
        break;
    case "nb-NO":
        Date.CultureInfo = Date.CultureInfo = { name: "nb-NO", englishName: "Norwegian, Bokmål (Norway)", nativeName: "norsk, bokmål (Norge)", dayNames: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"], abbreviatedDayNames: ["sø", "ma", "ti", "on", "to", "fr", "lø"], shortestDayNames: ["sø", "ma", "ti", "on", "to", "fr", "lø"], firstLetterDayNames: ["s", "m", "t", "o", "t", "f", "l"], monthNames: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"], abbreviatedMonthNames: ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"], amDesignator: "", pmDesignator: "", firstDayOfWeek: 1, twoDigitYearMax: 2029, dateElementOrder: "dmy", formatPatterns: { shortDate: "dd.MM.yyyy", longDate: "d. MMMM yyyy", shortTime: "HH:mm", longTime: "HH:mm:ss", fullDateTime: "d. MMMM yyyy HH:mm:ss", sortableDateTime: "yyyy-MM-ddTHH:mm:ss", universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ", rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT", monthDay: "d. MMMM", yearMonth: "MMMM yyyy" }, regexPatterns: { jan: /^jan(uar)?/i, feb: /^feb(ruar)?/i, mar: /^mar(s)?/i, apr: /^apr(il)?/i, may: /^mai/i, jun: /^jun(i)?/i, jul: /^jul(i)?/i, aug: /^aug(ust)?/i, sep: /^sep(t(ember)?)?/i, oct: /^okt(ober)?/i, nov: /^nov(ember)?/i, dec: /^des(ember)?/i, sun: /^søndag/i, mon: /^mandag/i, tue: /^tirsdag/i, wed: /^onsdag/i, thu: /^torsdag/i, fri: /^fredag/i, sat: /^lørdag/i, future: /^next/i, past: /^last|past|prev(ious)?/i, add: /^(\+|aft(er)?|from|hence)/i, subtract: /^(\-|bef(ore)?|ago)/i, yesterday: /^yes(terday)?/i, today: /^t(od(ay)?)?/i, tomorrow: /^tom(orrow)?/i, now: /^n(ow)?/i, millisecond: /^ms|milli(second)?s?/i, second: /^sec(ond)?s?/i, minute: /^mn|min(ute)?s?/i, hour: /^h(our)?s?/i, week: /^w(eek)?s?/i, month: /^m(onth)?s?/i, day: /^d(ay)?s?/i, year: /^y(ear)?s?/i, shortMeridian: /^(a|p)/i, longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i, timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i, ordinalSuffix: /^\s*(st|nd|rd|th)/i, timeContext: /^\s*(\:|a(?!u|p)|p)/i }, timezones: [{ name: "UTC", offset: "-000" }, { name: "GMT", offset: "-000" }, { name: "EST", offset: "-0500" }, { name: "EDT", offset: "-0400" }, { name: "CST", offset: "-0600" }, { name: "CDT", offset: "-0500" }, { name: "MST", offset: "-0700" }, { name: "MDT", offset: "-0600" }, { name: "PST", offset: "-0800" }, { name: "PDT", offset: "-0700" }] };
        break;
    case "sv-SE":
        Date.CultureInfo = Date.CultureInfo = {
            name: "sv-SE",
            englishName: "Swedish (Sweden)",
            nativeName: "svenska (Sverige)",
            dayNames: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
            abbreviatedDayNames: ["sö", "må", "ti", "on", "to", "fr", "lö"],
            shortestDayNames: ["sö", "må", "ti", "on", "to", "fr", "lö"],
            firstLetterDayNames: ["s", "m", "t", "o", "t", "f", "l"],
            monthNames: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
            abbreviatedMonthNames: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
            amDesignator: "",
            pmDesignator: "",
            firstDayOfWeek: 1,
            twoDigitYearMax: 2029,
            dateElementOrder: "ymd",
            formatPatterns: {
                shortDate: "yyyy-MM-dd",
                longDate: "'den 'd MMMM yyyy",
                shortTime: "HH:mm",
                longTime: "HH:mm:ss",
                fullDateTime: "'den 'd MMMM yyyy HH:mm:ss",
                sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                monthDay: "'den 'd MMMM",
                yearMonth: "MMMM yyyy"
            },
            regexPatterns: {
                jan: /^jan(uari)?/i,
                feb: /^feb(ruari)?/i,
                mar: /^mar(s)?/i,
                apr: /^apr(il)?/i,
                may: /^maj/i,
                jun: /^jun(i)?/i,
                jul: /^jul(i)?/i,
                aug: /^aug(usti)?/i,
                sep: /^sep(t(ember)?)?/i,
                oct: /^okt(ober)?/i,
                nov: /^nov(ember)?/i,
                dec: /^dec(ember)?/i,
                sun: /^söndag/i,
                mon: /^måndag/i,
                tue: /^tisdag/i,
                wed: /^onsdag/i,
                thu: /^torsdag/i,
                fri: /^fredag/i,
                sat: /^lördag/i,
                future: /^next/i,
                past: /^last|past|prev(ious)?/i,
                add: /^(\+|aft(er)?|from|hence)/i,
                subtract: /^(\-|bef(ore)?|ago)/i,
                yesterday: /^yes(terday)?/i,
                today: /^t(od(ay)?)?/i,
                tomorrow: /^tom(orrow)?/i,
                now: /^n(ow)?/i,
                millisecond: /^ms|milli(second)?s?/i,
                second: /^sec(ond)?s?/i,
                minute: /^mn|min(ute)?s?/i,
                hour: /^h(our)?s?/i,
                week: /^w(eek)?s?/i,
                month: /^m(onth)?s?/i,
                day: /^d(ay)?s?/i,
                year: /^y(ear)?s?/i,
                shortMeridian: /^(a|p)/i,
                longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
                timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
                ordinalSuffix: /^\s*(st|nd|rd|th)/i,
                timeContext: /^\s*(\:|a(?!u|p)|p)/i
            },
            timezones: [{ name: "UTC", offset: "-000" }, { name: "GMT", offset: "-000" }, { name: "EST", offset: "-0500" }, { name: "EDT", offset: "-0400" }, { name: "CST", offset: "-0600" }, { name: "CDT", offset: "-0500" }, { name: "MST", offset: "-0700" }, { name: "MDT", offset: "-0600" }, { name: "PST", offset: "-0800" }, { name: "PDT", offset: "-0700" }]
        };
        break;
    case "de-DE":
        Date.CultureInfo = { name: "de-DE", englishName: "German (Germany)", nativeName: "Deutsch (Deutschland)", dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"], abbreviatedDayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], shortestDayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], firstLetterDayNames: ["S", "M", "D", "M", "D", "F", "S"], monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], abbreviatedMonthNames: ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], amDesignator: "", pmDesignator: "", firstDayOfWeek: 1, twoDigitYearMax: 2029, dateElementOrder: "dmy", formatPatterns: { shortDate: "dd.MM.yyyy", longDate: "dddd, d. MMMM yyyy", shortTime: "HH:mm", longTime: "HH:mm:ss", fullDateTime: "dddd, d. MMMM yyyy HH:mm:ss", sortableDateTime: "yyyy-MM-ddTHH:mm:ss", universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ", rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT", monthDay: "dd MMMM", yearMonth: "MMMM yyyy" }, regexPatterns: { jan: /^jan(uar)?/i, feb: /^feb(ruar)?/i, mar: /^märz/i, apr: /^apr(il)?/i, may: /^mai/i, jun: /^jun(i)?/i, jul: /^jul(i)?/i, aug: /^aug(ust)?/i, sep: /^sep(t(ember)?)?/i, oct: /^okt(ober)?/i, nov: /^nov(ember)?/i, dec: /^dez(ember)?/i, sun: /^so(n(ntag)?)?/i, mon: /^mo(n(tag)?)?/i, tue: /^di(e(nstag)?)?/i, wed: /^mi(t(twoch)?)?/i, thu: /^do(n(nerstag)?)?/i, fri: /^fr(e(itag)?)?/i, sat: /^sa(m(stag)?)?/i, future: /^next/i, past: /^last|past|prev(ious)?/i, add: /^(\+|aft(er)?|from|hence)/i, subtract: /^(\-|bef(ore)?|ago)/i, yesterday: /^yes(terday)?/i, today: /^t(od(ay)?)?/i, tomorrow: /^tom(orrow)?/i, now: /^n(ow)?/i, millisecond: /^ms|milli(second)?s?/i, second: /^sec(ond)?s?/i, minute: /^mn|min(ute)?s?/i, hour: /^h(our)?s?/i, week: /^w(eek)?s?/i, month: /^m(onth)?s?/i, day: /^d(ay)?s?/i, year: /^y(ear)?s?/i, shortMeridian: /^(a|p)/i, longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i, timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i, ordinalSuffix: /^\s*(st|nd|rd|th)/i, timeContext: /^\s*(\:|a(?!u|p)|p)/i }, timezones: [{ name: "UTC", offset: "-000" }, { name: "GMT", offset: "-000" }, { name: "EST", offset: "-0500" }, { name: "EDT", offset: "-0400" }, { name: "CST", offset: "-0600" }, { name: "CDT", offset: "-0500" }, { name: "MST", offset: "-0700" }, { name: "MDT", offset: "-0600" }, { name: "PST", offset: "-0800" }, { name: "PDT", offset: "-0700" }] };
        break;

    case "nl-NL":
        Date.CultureInfo = {
            name: "nl-NL",
            englishName: "Dutch (Netherlands)",
            nativeName: "Nederlands (Nederland)",

            dayNames: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
            abbreviatedDayNames: ["zo", "ma", "di", "wo", "do", "vr", "za"],
            shortestDayNames: ["zo", "ma", "di", "wo", "do", "vr", "za"],
            firstLetterDayNames: ["z", "m", "d", "w", "d", "v", "z"],

            monthNames: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
            abbreviatedMonthNames: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],

            amDesignator: "",
            pmDesignator: "",
            firstDayOfWeek: 1,
            twoDigitYearMax: 2029,
            dateElementOrder: "dmy",

            formatPatterns: {
                shortDate: "dd-MM-yyyy",
                longDate: "d MMMM yyyy",
                shortTime: "HH:mm",
                longTime: "HH:mm:ss",
                fullDateTime: "d MMMM yyyy HH:mm:ss",
                sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                monthDay: "d MMMM",
                yearMonth: "MMMM yyyy"
            },

            regexPatterns: {
                jan: /^jan(uari)?/i,
                feb: /^feb(ruari)?/i,
                mar: /^mrt|maa(rt)?/i,
                apr: /^apr(il)?/i,
                may: /^mei/i,
                jun: /^jun(i)?/i,
                jul: /^jul(i)?/i,
                aug: /^aug(ustus)?/i,
                sep: /^sep(t(ember)?)?/i,
                oct: /^okt(ober)?/i,
                nov: /^nov(ember)?/i,
                dec: /^dec(ember)?/i,

                sun: /^zon(dag)?/i,
                mon: /^maan(dag)?/i,
                tue: /^dins(dag)?/i,
                wed: /^woens(dag)?/i,
                thu: /^donder(dag)?/i,
                fri: /^vrij(dag)?/i,
                sat: /^zater(dag)?/i,

                future: /^volgende|next/i,
                past: /^vorige|laatste|past|prev(ious)?/i,
                add: /^(\+|na|vanaf|over)/i,
                subtract: /^(\-|voor|geleden)/i,

                yesterday: /^gisteren/i,
                today: /^vandaag/i,
                tomorrow: /^morgen/i,
                now: /^nu/i,

                millisecond: /^ms|milli(seconde)?n?/i,
                second: /^sec(onde)?n?/i,
                minute: /^min(uu?t)?en?/i,
                hour: /^uur?/i,
                week: /^week(en)?/i,
                month: /^maand(en)?/i,
                day: /^dag(en)?/i,
                year: /^jaar(en)?/i,

                shortMeridian: /^(a|p)/i,
                longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
                timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
                ordinalSuffix: /^\s*(e|ste|de)/i,
                timeContext: /^\s*(\:|a(?!u|p)|p)/i
            },

            timezones: [
                { name: "UTC", offset: "-000" },
                { name: "GMT", offset: "-000" },
                { name: "EST", offset: "-0500" },
                { name: "EDT", offset: "-0400" },
                { name: "CST", offset: "-0600" },
                { name: "CDT", offset: "-0500" },
                { name: "MST", offset: "-0700" },
                { name: "MDT", offset: "-0600" },
                { name: "PST", offset: "-0800" },
                { name: "PDT", offset: "-0700" }
            ]
        };

        break;

    case "da-DK":
        Date.CultureInfo = { name: "da-DK", englishName: "Danish (Denmark)", nativeName: "dansk (Danmark)", dayNames: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"], abbreviatedDayNames: ["sø", "ma", "ti", "on", "to", "fr", "lø"], shortestDayNames: ["sø", "ma", "ti", "on", "to", "fr", "lø"], firstLetterDayNames: ["s", "m", "t", "o", "t", "f", "l"], monthNames: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"], abbreviatedMonthNames: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"], amDesignator: "", pmDesignator: "", firstDayOfWeek: 1, twoDigitYearMax: 2029, dateElementOrder: "dmy", formatPatterns: { shortDate: "dd-MM-yyyy", longDate: "d. MMMM yyyy", shortTime: "HH:mm", longTime: "HH:mm:ss", fullDateTime: "d. MMMM yyyy HH:mm:ss", sortableDateTime: "yyyy-MM-ddTHH:mm:ss", universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ", rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT", monthDay: "d. MMMM", yearMonth: "MMMM yyyy" }, regexPatterns: { jan: /^jan(uar)?/i, feb: /^feb(ruar)?/i, mar: /^mar(ts)?/i, apr: /^apr(il)?/i, may: /^maj/i, jun: /^jun(i)?/i, jul: /^jul(i)?/i, aug: /^aug(ust)?/i, sep: /^sep(t(ember)?)?/i, oct: /^okt(ober)?/i, nov: /^nov(ember)?/i, dec: /^dec(ember)?/i, sun: /^søndag/i, mon: /^mandag/i, tue: /^tirsdag/i, wed: /^onsdag/i, thu: /^torsdag/i, fri: /^fredag/i, sat: /^lørdag/i, future: /^next/i, past: /^last|past|prev(ious)?/i, add: /^(\+|aft(er)?|from|hence)/i, subtract: /^(\-|bef(ore)?|ago)/i, yesterday: /^yes(terday)?/i, today: /^t(od(ay)?)?/i, tomorrow: /^tom(orrow)?/i, now: /^n(ow)?/i, millisecond: /^ms|milli(second)?s?/i, second: /^sec(ond)?s?/i, minute: /^mn|min(ute)?s?/i, hour: /^h(our)?s?/i, week: /^w(eek)?s?/i, month: /^m(onth)?s?/i, day: /^d(ay)?s?/i, year: /^y(ear)?s?/i, shortMeridian: /^(a|p)/i, longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i, timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i, ordinalSuffix: /^\s*(st|nd|rd|th)/i, timeContext: /^\s*(\:|a(?!u|p)|p)/i }, timezones: [{ name: "UTC", offset: "-000" }, { name: "GMT", offset: "-000" }, { name: "EST", offset: "-0500" }, { name: "EDT", offset: "-0400" }, { name: "CST", offset: "-0600" }, { name: "CDT", offset: "-0500" }, { name: "MST", offset: "-0700" }, { name: "MDT", offset: "-0600" }, { name: "PST", offset: "-0800" }, { name: "PDT", offset: "-0700" }] };
        break;

    case "fr-FR":
        Date.CultureInfo = {
            name: "fr-FR",
            englishName: "French (France)",
            nativeName: "français (France)",

            dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            abbreviatedDayNames: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
            shortestDayNames: ["di", "lu", "ma", "me", "je", "ve", "sa"],
            firstLetterDayNames: ["d", "l", "m", "m", "j", "v", "s"],

            monthNames: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
            abbreviatedMonthNames: ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"],

            amDesignator: "",
            pmDesignator: "",
            firstDayOfWeek: 1,
            twoDigitYearMax: 2029,
            dateElementOrder: "dmy",

            formatPatterns: {
                shortDate: "dd/MM/yyyy",
                longDate: "d MMMM yyyy",
                shortTime: "HH:mm",
                longTime: "HH:mm:ss",
                fullDateTime: "d MMMM yyyy HH:mm:ss",
                sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                monthDay: "d MMMM",
                yearMonth: "MMMM yyyy"
            },

            regexPatterns: {
                jan: /^jan(vier)?/i,
                feb: /^fév(r(ier)?)?/i,
                mar: /^mars/i,
                apr: /^avr(il)?/i,
                may: /^mai/i,
                jun: /^juin/i,
                jul: /^juil(let)?/i,
                aug: /^aoû?t/i,
                sep: /^sep(t(embre)?)?/i,
                oct: /^oct(obre)?/i,
                nov: /^nov(embre)?/i,
                dec: /^déc(embre)?/i,

                sun: /^dim(anche)?/i,
                mon: /^lun(di)?/i,
                tue: /^mar(di)?/i,
                wed: /^mer(credi)?/i,
                thu: /^jeu(di)?/i,
                fri: /^ven(dredi)?/i,
                sat: /^sam(edi)?/i,

                future: /^prochain|suivant|next/i,
                past: /^dernier|passé|préc(édent)?|prev(ious)?/i,
                add: /^(\+|après|dans|en)/i,
                subtract: /^(\-|avant|il y a)/i,

                yesterday: /^hier/i,
                today: /^aujourd'hui/i,
                tomorrow: /^demain/i,
                now: /^maintenant/i,

                millisecond: /^ms|milli(seconde)?s?/i,
                second: /^sec(onde)?s?/i,
                minute: /^min(ute)?s?/i,
                hour: /^h(eure)?s?/i,
                week: /^sem(aine)?s?/i,
                month: /^mois/i,
                day: /^jour(s)?/i,
                year: /^an(née)?s?/i,

                shortMeridian: /^(a|p)/i,
                longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
                timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
                ordinalSuffix: /^\s*(er|e|ème)/i,
                timeContext: /^\s*(\:|a(?!u|p)|p)/i
            },

            timezones: [
                { name: "UTC", offset: "-000" },
                { name: "GMT", offset: "-000" },
                { name: "EST", offset: "-0500" },
                { name: "EDT", offset: "-0400" },
                { name: "CST", offset: "-0600" },
                { name: "CDT", offset: "-0500" },
                { name: "MST", offset: "-0700" },
                { name: "MDT", offset: "-0600" },
                { name: "PST", offset: "-0800" },
                { name: "PDT", offset: "-0700" }
            ]
        };
        break;

    case "es-ES":
        Date.CultureInfo = {
            name: "es-ES",
            englishName: "Spanish (Spain)",
            nativeName: "español (España)",

            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            abbreviatedDayNames: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            shortestDayNames: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
            firstLetterDayNames: ["d", "l", "m", "m", "j", "v", "s"],

            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            abbreviatedMonthNames: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],

            amDesignator: "",
            pmDesignator: "",
            firstDayOfWeek: 1,
            twoDigitYearMax: 2029,
            dateElementOrder: "dmy",

            formatPatterns: {
                shortDate: "dd/MM/yyyy",
                longDate: "d 'de' MMMM 'de' yyyy",
                shortTime: "HH:mm",
                longTime: "HH:mm:ss",
                fullDateTime: "d 'de' MMMM 'de' yyyy HH:mm:ss",
                sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                monthDay: "d 'de' MMMM",
                yearMonth: "MMMM 'de' yyyy"
            },

            regexPatterns: {
                jan: /^ene(ro)?/i,
                feb: /^feb(rero)?/i,
                mar: /^mar(zo)?/i,
                apr: /^abr(il)?/i,
                may: /^may(o)?/i,
                jun: /^jun(io)?/i,
                jul: /^jul(io)?/i,
                aug: /^ago(sto)?/i,
                sep: /^sep(t(iembre)?)?/i,
                oct: /^oct(ubre)?/i,
                nov: /^nov(iembre)?/i,
                dec: /^dic(iembre)?/i,

                sun: /^dom(ingo)?/i,
                mon: /^lun(es)?/i,
                tue: /^mar(tes)?/i,
                wed: /^mié(rcoles)?/i,
                thu: /^jue(ves)?/i,
                fri: /^vie(rnes)?/i,
                sat: /^sáb(ado)?/i,

                future: /^próximo|siguiente|next/i,
                past: /^pasado|anterior|prev(ious)?/i,
                add: /^(\+|después|en)/i,
                subtract: /^(\-|antes|hace)/i,

                yesterday: /^ayer/i,
                today: /^hoy/i,
                tomorrow: /^mañana/i,
                now: /^ahora/i,

                millisecond: /^ms|mili(segundo)?s?/i,
                second: /^seg(undo)?s?/i,
                minute: /^min(uto)?s?/i,
                hour: /^h(ora)?s?/i,
                week: /^sem(ana)?s?/i,
                month: /^mes(es)?/i,
                day: /^d(ía)?s?/i,
                year: /^a(ño)?s?/i,

                shortMeridian: /^(a|p)/i,
                longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
                timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
                ordinalSuffix: /^\s*(º|ª)/i,
                timeContext: /^\s*(\:|a(?!u|p)|p)/i
            },

            timezones: [
                { name: "UTC", offset: "-000" },
                { name: "GMT", offset: "-000" },
                { name: "EST", offset: "-0500" },
                { name: "EDT", offset: "-0400" },
                { name: "CST", offset: "-0600" },
                { name: "CDT", offset: "-0500" },
                { name: "MST", offset: "-0700" },
                { name: "MDT", offset: "-0600" },
                { name: "PST", offset: "-0800" },
                { name: "PDT", offset: "-0700" }
            ]
        };

        break;

    case "fi-FI":
        Date.CultureInfo = {
            name: "fi-FI",
            englishName: "Finnish (Finland)",
            nativeName: "suomi (Suomi)",

            dayNames: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"],
            abbreviatedDayNames: ["su", "ma", "ti", "ke", "to", "pe", "la"],
            shortestDayNames: ["su", "ma", "ti", "ke", "to", "pe", "la"],
            firstLetterDayNames: ["s", "m", "t", "k", "t", "p", "l"],

            monthNames: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"],
            abbreviatedMonthNames: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],

            amDesignator: "",
            pmDesignator: "",
            firstDayOfWeek: 1,
            twoDigitYearMax: 2029,
            dateElementOrder: "dmy",

            formatPatterns: {
                shortDate: "d.M.yyyy",
                longDate: "d. MMMM yyyy",
                shortTime: "H:mm",
                longTime: "H:mm:ss",
                fullDateTime: "d. MMMM yyyy H:mm:ss",
                sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                monthDay: "d. MMMM",
                yearMonth: "MMMM yyyy"
            },

            regexPatterns: {
                jan: /^tammi(kuu)?/i,
                feb: /^helmi(kuu)?/i,
                mar: /^maalis(kuu)?/i,
                apr: /^huhti(kuu)?/i,
                may: /^touko(kuu)?/i,
                jun: /^kesä(kuu)?/i,
                jul: /^heinä(kuu)?/i,
                aug: /^elo(kuu)?/i,
                sep: /^syys(kuu)?/i,
                oct: /^loka(kuu)?/i,
                nov: /^marras(kuu)?/i,
                dec: /^joulu(kuu)?/i,

                sun: /^sunnuntai/i,
                mon: /^maanantai/i,
                tue: /^tiistai/i,
                wed: /^keskiviikko/i,
                thu: /^torstai/i,
                fri: /^perjantai/i,
                sat: /^lauantai/i,

                future: /^seuraava|tuleva|next/i,
                past: /^viime|edellinen|prev(ious)?/i,
                add: /^(\+|jälkeen|lisää)/i,
                subtract: /^(\-|ennen|vähennä)/i,

                yesterday: /^eilen/i,
                today: /^tänään/i,
                tomorrow: /^huomenna/i,
                now: /^nyt/i,

                millisecond: /^ms|millisek(unti)?a?/i,
                second: /^sek(unti)?a?/i,
                minute: /^min(uutti)?a?/i,
                hour: /^t(unti)?a?/i,
                week: /^viik(ko)?a?/i,
                month: /^kuu(kausi)?a?/i,
                day: /^päiv(ä)?a?/i,
                year: /^vuos(i)?a?/i,

                shortMeridian: /^(a|p)/i,
                longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
                timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,
                ordinalSuffix: /^\s*(\.)/i,
                timeContext: /^\s*(\:|a(?!u|p)|p)/i
            },

            timezones: [
                { name: "UTC", offset: "-000" },
                { name: "GMT", offset: "-000" },
                { name: "EET", offset: "+0200" },
                { name: "EEST", offset: "+0300" },
                { name: "CET", offset: "+0100" },
                { name: "CEST", offset: "+0200" },
                { name: "PST", offset: "-0800" },
                { name: "PDT", offset: "-0700" },
                { name: "EST", offset: "-0500" },
                { name: "EDT", offset: "-0400" }
            ]
        };

        break;

    default:
        debugger;
        alert("unknown dataculture: " + language);
        break;
}